export default __webpack_public_path__ + "static/icon-fr-b70c7a2a5e8350cf2b0e2d40a073dede.png";